import { Image } from "@chakra-ui/react";
import logo from "../../../assets/logo_no_name.png";
import "./spinning.css";

export default function TalesSpinner() {
  return (
    <div className="rotating">
      <Image src={logo} w="30px" />
    </div>
  );
}
